import { TemplateRef, } from '@angular/core';
import { animationFrameScheduler, BehaviorSubject, } from 'rxjs';
import { observeOn, } from 'rxjs/operators';
import * as i0 from "@angular/core";
var HeaderOverrideService = /** @class */ (function () {
    function HeaderOverrideService() {
        this._template$ = new BehaviorSubject(null);
        this.template$ = this._template$
            .asObservable()
            .pipe(observeOn(animationFrameScheduler));
    }
    HeaderOverrideService.prototype.set = function (tpl) {
        this._template$.next(tpl);
    };
    HeaderOverrideService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HeaderOverrideService_Factory() { return new HeaderOverrideService(); }, token: HeaderOverrideService, providedIn: "root" });
    return HeaderOverrideService;
}());
export { HeaderOverrideService };
